import React, {useContext, useEffect, useState} from 'react';
import './Menu.scss'
import AKTS_logo from '../assets/AKTS_logo.png';
import MenuButton from '../assets/Home.png';
import {useNavigate} from "react-router-dom";
import {UserInfoContext} from "../context/UserInfoContext";
import mqttRequests from "./mqttRequests";
import {MqttClientContext} from "../context/MqttClientContext";
import login from '../assets/LoginNoMessage.png';
import logout from '../assets/LogoutNoMessage.png';
import NavDropdown from 'react-bootstrap/NavDropdown';

//page for the left menu
function Menu(props) {

    //setters to update some variables
    const clicked = props.menuClicked;
    const setClicked = props.setMenuClicked;
    const setIdUser = props.setIdUser;
    const setIdAccount = props.setIdAccount;
    const setIdRight = props.setIdRight;
    const refreshSource = props.refreshSource;
    const setRefreshSource = props.setRefreshSource;

    let navigate = useNavigate();

    //the contexts
    const {idUser, idRight} = useContext(UserInfoContext);

    //context for mqtt
    const {mqttClient, source} = useContext(MqttClientContext)

    const [showManag, setShowManag] = useState(false);
    const [showAlarm, setShowAlarm] = useState(false);

    //variable to manage the display if the user have the rights
    const [UserManagementRight, setUserManagementRight] = useState(false);

    //connect to the client when the page opens
    useEffect(() => {
        if(idUser !== ""){
            if(idRight !== null){
                try{
                    setUserManagementRight(idRight.includes("02112221623298373532"));
                } catch (error) {
                    console.error(error);
                    setUserManagementRight(false);
                }
            }
        }
    }, [idRight, idUser]);

    //get the rights at each refresh
    useEffect(() => {
        if(mqttClient !== null){
            //generate operation code
            const operation = mqttRequests.generateOperationCode("getRightsFromUser");

            //create json to publish
            const data = '{"operation":"' + operation + '", "source":"' + source + '", "idUser":"' + idUser + '"}';

            //subscribe to the channel to wait for the mqtt response
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getRightsFromUser");

            //publish a demand to get all the user groups
            mqttRequests.publish(mqttClient, "user/getRightsFromUser", data);

            //read incoming message and send response to a function to refactor them
            mqttRequests.incomingMessage((message) => {
                let jsonParsed = JSON.parse(message.toString());
                if(jsonParsed.idRight){
                    setIdRight(jsonParsed.idRight);
                    localStorage.setItem("idRight", JSON.stringify(jsonParsed.idRight));
                }
            })
        }
    }, [mqttClient, idUser, setIdRight, source]);

    const clickHome = () => {
        navigate("/");
        setClicked("home");
    }

    const clickNavigate = (destination) => {
        setClicked(destination);
        navigate("/" + destination);
    }

    const clickLogout = () => {
        mqttRequests.unSubscribe(mqttClient, "device/list/" + localStorage.getItem("idAccount"));
        localStorage.setItem("idUser", "");
        localStorage.setItem("idAccount", "");
        localStorage.setItem("idRight", "{}");
        setIdUser("");
        setIdAccount("");
        setIdRight("");
        setClicked("Home");
        setRefreshSource(!refreshSource);
        navigate("/");
    }

    return(
        <>
            <div className="MenuMainDiv">
                <img src={AKTS_logo} alt="AKTS logo" className="MenuImg" onClick={clickHome}/>
                {idUser === "" ?
                    <img src={MenuButton} alt="AKTS logo" className="MenubuttonTopLogout" onClick={clickHome}/>
                    :
                    <img src={MenuButton} alt="AKTS logo" className="MenubuttonTop" onClick={clickHome}/>
                }
                {idUser !== ""?
                    <div className="MenuFlex">
                        <div className="MenuText">
                            <p style={{"color": clicked==="missions"? "#4696d2" : "black"}} onClick={() => clickNavigate("missions")}>Missions</p>
                            <p style={{"color": clicked==="deviceList"? "#4696d2" : "black"}} onClick={() => clickNavigate("deviceList")}>Devices</p>
                            <p style={{"color": clicked==="getGroupDevice"? "#4696d2" : "black"}} onClick={() => clickNavigate("getGroupDevice")}>Device groups</p>
                            <p style={{"color": clicked==="getKinetics"? "#4696d2" : "black"}} onClick={() => clickNavigate("getKinetics")}>Kinetics library</p>
                        </div>
                        <NavDropdown title="Alarms" className="menuAlarm" style={{"color": clicked==="supervision"||clicked==="alarms"||clicked==="recipient"? "#4696d2" : "black"}}
                                    show={showAlarm} onMouseEnter={() => setShowAlarm(true)} onMouseLeave={() => setShowAlarm(false)}>
                            <NavDropdown.Item style={{"color": clicked==="supervision"? "#4696d2" : "black"}} onClick={() => clickNavigate("supervision")}>Supervisions</NavDropdown.Item>
                            <NavDropdown.Item style={{"color": clicked==="alarms"? "#4696d2" : "black"}} onClick={() => clickNavigate("alarms")}>History</NavDropdown.Item>
                            <NavDropdown.Item style={{"color": clicked==="recipient"? "#4696d2" : "black"}} onClick={() => clickNavigate("recipient")}>Recipients</NavDropdown.Item>
                        </NavDropdown>
                        {UserManagementRight?
                        <NavDropdown title="Management" className="menuManage" style={{"color": clicked==="userManagement"||clicked==="groupManagement"||clicked==="settings"? "#4696d2" : "black"}}
                                     show={showManag} onMouseEnter={() => setShowManag(true)} onMouseLeave={() => setShowManag(false)}>
                            <NavDropdown.Item style={{"color": clicked==="userManagement"? "#4696d2" : "black"}} onClick={() => clickNavigate("userManagement")}>Users</NavDropdown.Item>
                            <NavDropdown.Item style={{"color": clicked==="groupManagement"? "#4696d2" : "black"}} onClick={() => clickNavigate("groupManagement")}>Groups</NavDropdown.Item>
                            <NavDropdown.Item style={{"color": clicked==="settings"? "#4696d2" : "black"}} onClick={() => clickNavigate("settings")}>Settings</NavDropdown.Item>
                        </NavDropdown>
                            :
                            null
                        }
                    </div>
                    :
                    null
                }
                <div className="MenuText">
                    {idUser === "" ?
                        <img onClick={() => clickNavigate("login")} src={login} alt="Logout" className="MenuLogout"/>
                        :
                        <img onClick={clickLogout} src={logout} alt="Logout" className="MenuLogout"/>
                    }
                </div>
            </div>
            <div className="mobileMenu">
                <img src={MenuButton} alt="AKTS logo" className="Menubutton" onClick={clickHome}/>
            </div>
        </>
    )
}

export default Menu;